import { Takeoff } from "@shared/types";
import { Box, IconButton, Tooltip, Typography, useTheme } from "@mui/material";
import { IcIcon } from "@shared/components";
import { FunctionComponent } from "react";
import {gql} from '@apollo/client';
import {useMutation} from '@apollo/client/react';

export const LOCK_TAKEOFF = gql`
  mutation LockTakeoff($id: String!) {
    lockTakeoff(input: { id: $id }) {
      _id
      locked
      unlockedUntil
    }
  }
`;
export const UNLOCK_TAKEOFF = gql`
  mutation UnLockTakeoff($id: String!) {
    unlockTakeoff(input: { id: $id }) {
      _id
      locked
      unlockedUntil
    }
  }
`;

export const LockButton: FunctionComponent<{
  takeoff: {
    locked?: boolean;
    unlockedUntil?: number;
    needsInventorySync?: boolean;
  } & Partial<Takeoff>;
  onChange?: () => void;
}> = ({ takeoff, onChange }) => {
  const theme = useTheme();
  const [lockTakeoff] = useMutation(LOCK_TAKEOFF, {
    variables: {
      id: takeoff._id,
    },
  });
  const [unlockTakeoff] = useMutation(UNLOCK_TAKEOFF, {
    variables: {
      id: takeoff._id,
    },
  });
  if (!takeoff) return null;

  const needsSync = takeoff.needsInventorySync === true;
  // Disable locking (not unlocking) when sync is needed
  const disableLock = needsSync && !takeoff.locked;

  const button = (
    <IconButton
      disabled={disableLock}
      onClick={() =>
        (takeoff.locked ? unlockTakeoff() : lockTakeoff()).then(() => {
          onChange && onChange();
        })
      }
    >
      <IcIcon
        sx={{
          color: disableLock
            ? theme.palette.grey[400]
            : takeoff.locked
              ? theme.palette.error.main
              : theme.palette.success.main,
        }}
        icon={takeoff.locked ? "mdi:archive-lock" : "mdi:archive-clock"}
      />
    </IconButton>
  );

  if (disableLock) {
    return (
      <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
        <Tooltip title="Sync required before locking. Close the edit modal to sync.">
          <span>{button}</span>
        </Tooltip>
        <Typography
          sx={{
            fontSize: 12,
            fontWeight: "bold",
            color: theme.palette.warning.main,
            whiteSpace: "nowrap",
          }}
        >
          Sync Required
        </Typography>
      </Box>
    );
  }

  return button;
};
